import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-predefine-var-list",
  templateUrl: "./predefine-var-list.component.html",
  styleUrls: ["./predefine-var-list.component.scss"],
})
export class PredefineVarListComponent implements OnInit {
  @ViewChild("templateVariableModal", { static: true })
  templateVariableModal: TemplateRef<any>;

  @Input() predefinedVariables = [];
  @Input() infoText = "";
  @Input() linkText = "";
  @Input() isVarClickable: boolean = false;
  @Input() addLeftSpacing: boolean = true;
  @Output() selectedVariable = new EventEmitter<boolean>();

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {}

  openTemplateVariableModal() {
    this.modalService.open(this.templateVariableModal);
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onVarSelect(variable) {
    // add extra condition that base on you want to emit var or not
    // (i.e messaging free form only etc)
    if (this.isVarClickable) {
      this.selectedVariable.emit(variable);
    }
  }
}
